<script setup>
import { url } from '@/config/urls';
import router from '@/router/index.js';

const props = defineProps({
  orderSearchPageUrl: {
    type: String,
    default: url.page.orderSearch
  },
  orderFavoritePageUrl: {
    type: String,
    default: url.page.orderFavorite
  }
});

const goToOrderSearch = () => {
  router.push(props.orderSearchPageUrl);
}

const goToOrderFavorite = () => {
  router.push(props.orderFavoritePageUrl);
}


</script>

<template>
  <div class="modal com_modal2 fade" id="addToFavoriteCompleteModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_c_check1.png" alt="" class="icon_c_check1">
          <h3 class="com_fs18 com_strong1 com_center1 com_mgb0">商品をお気に入りに登録しました</h3>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1 wd1" @click="goToOrderSearch">発注TOP</button>
        </div>
        <div class="sub_cnt1">
          <p class="com_fs12 com_center1"><a class="com_link2" @click="goToOrderFavorite">お気に入りグループの編集はこちらから</a></p>
        </div>
      </div>
    </div>
  </div>
</template>
